import { eTipoPermissao } from '@/enums/ePermissoes';

export default [
  {
    description: 'Grupo de Participantes',
    path: '/gestao/gesparticipantegrupo',
    name: 'gestao.gesparticipantegrupo',
    component: () => import('@/views/gestao/gesparticipantegrupo/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.GRUPODEPARTICIPANTESNOVO_MENU_2100200298],
    },
    goesToMenu: true,
  },
  {
    description: 'Cadastro de Grupo de Participantes',
    path: '/gestao/gesparticipantegrupo/cadastro/:id?',
    parent: 'gestao.gesparticipantegrupo',
    name: 'gestao.gesparticipantegrupo_create',
    component: () => import('@/views/gestao/gesparticipantegrupo/InclusaoEdicao.vue'),
    meta: {
      permissions: [eTipoPermissao.GRUPODEPARTICIPANTESNOVO_MENU_2100200298],
    },
    goesToMenu: true,
  },
];
